export default {
      id: "ic_membership-usage",
      viewBox: "0 0 40 40",
      url: "/" + "images/icons.3.109.2.svg#ic_membership-usage",
      toString: function () {
        return this.url;
      }
    }